import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import CommentPost from 'flarum/forum/components/CommentPost';
import PostControls from 'flarum/forum/utils/PostControls';
import Icon from 'flarum/common/components/Icon';
import extractText from 'flarum/common/utils/extractText';

// What fof/best-answer adds to the models.

/** The best answer of the post's discussion, if it has one. */
function bestAnswerOf(post) {
  const discussion = post.discussion();
  return discussion && discussion.bestAnswerPost() || null;
}

/**
 * fof/best-answer's "Alternative layout" (its admin setting) puts "Select
 * Best Answer" under each reply, next to Reply and Like. This makes it read
 * as the thing to press:
 * - the button gets a check icon;
 * - once a reply is the best answer, only that reply keeps a (quiet)
 *   control, to unselect it; no other reply can be chosen until then.
 *   The same goes for fof's default layout, in the post's "…" menu;
 * - the first post tells its author, while no reply is chosen yet, that
 *   this is how to mark the solution.
 *
 * fof/best-answer is an optional dependency, so its own extensions have run
 * by the time these see the items.
 */
export default function bestAnswer() {
  extend(CommentPost.prototype, 'actionItems', function (items) {
    if (!items.has('bestAnswer')) return;
    const post = this.attrs.post;
    const best = bestAnswerOf(post);
    if (best && best.id() !== post.id()) {
      items.remove('bestAnswer');
      return;
    }

    // No best answer yet: a green "✓ Select Best Answer". This post is the
    // best answer: a quiet "✕ Unselect Best Answer".
    const button = items.get('bestAnswer');
    button.attrs.icon = best ? 'fas fa-xmark' : 'fas fa-check';
    button.attrs.className = [...(button.attrs.className || 'Button').split(' ').filter(name => !best || name !== 'Button--primary'), best ? 'Button--link' : '', 'BdBestAnswerAction'].filter(Boolean).join(' ');
  });
  extend(PostControls, 'moderationControls', function (items, post) {
    const best = bestAnswerOf(post);
    if (items.has('bestAnswer') && best && best.id() !== post.id()) {
      items.remove('bestAnswer');
    }
  });
  extend(CommentPost.prototype, 'footerItems', function (items) {
    const post = this.attrs.post;
    if (post.number() !== 1 || !app.forum.attribute('useAlternativeBestAnswerUi')) return;
    const discussion = post.discussion();
    const author = discussion && discussion.user();
    const actor = app.session.user;
    if (!discussion || !author || !actor || author.id() !== actor.id() || discussion.hasBestAnswer?.()) return;
    const canSelect = (discussion.posts() || []).some(reply => reply && reply.number() > 1 && !reply.isHidden() && reply.canSelectAsBestAnswer?.());
    if (!canSelect) return;
    items.add('bdBestAnswerHint', m("div", {
      className: "BdBestAnswerHint"
    }, m(Icon, {
      name: "fas fa-circle-check"
    }), m("span", null, app.translator.trans('bimmerdock-theme.forum.best_answer.hint', {
      button: extractText(app.translator.trans('fof-best-answer.forum.this_best_answer'))
    }))), -10);
  });
}